// extracted by mini-css-extract-plugin
export default {"container":"fO-z","topReviewHeading":"gO-z","criticalReview":"hO-z","favorableReview":"iO-z","vsSeparator":"jO-z"};